/**
 * This is the entry file for the application.
 */
// Import all the third party stuff
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'focus-visible';
import { AuthProvider } from 'react-oidc-context';

import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import 'sanitize.css/sanitize.css';
import 'intersection-observer';
import { UICLThemeProvider, DragProvider } from '@uhg-uicl/ui-core/dist';

// Load the favicon and the .htaccess file
import './favicon.ico';
import './.htaccess';

// Import views
import ErrorBoundary from './ErrorBoundary';

import configureStore from './configureStore';
import GlobalStyle from './global-styles';

// Import all application routes
import ApplicationRoutes, { history } from './applicationRoutes';
import { sentinelConfig } from 'sentinelConfig';

// Add promise support to the global window object if not found
if (!window.Promise) window.Promise = Promise;

// Create redux store with history
const initialState = {};
export const store = configureStore(initialState, history);
const MOUNT_NODE = document.getElementById('app') as HTMLElement;

/**
 * The UICLThemeProvider below sets the global styles for the ui-core library. It is required to be there in any project
 * that uses UICL. See the production story book to view available themes and the latest documentation
 * https://prod.storybooks.awsprod.healthcareit.net/?path=/docs/documentation-changelog--page
 */
const render = () => {
  ReactDOM.render(
    <UICLThemeProvider theme="base" isAnalyticsEnabled={false}>
      <ErrorBoundary>
        <GlobalStyle />
        <Provider store={store}>
          <DragProvider>
            <AuthProvider {...sentinelConfig}>
              <ApplicationRoutes />
            </AuthProvider>
          </DragProvider>
        </Provider>
      </ErrorBoundary>
    </UICLThemeProvider>,
    MOUNT_NODE,
  );
};
//@ts-ignore
if (module.hot) {
  // Hot reloadable React components and translation json files
  // modules.hot.accept does not accept dynamic dependencies,
  // have to be constants at compile-time
  //@ts-ignore
  module.hot.accept(['./containers/PageWrapper'], () => {
    ReactDOM.unmountComponentAtNode(MOUNT_NODE);
    render();
  });
}

render();

// registerServiceWorker();
